import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock,
  Alert,
  Link,
  Modal,
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";
import "../../../style/subAdmin/SubAdmin.scss";
import { Notification } from "../../../components/notifications";
import isEmpty from "lodash.isempty";
import { getReport } from "../../../redux/actions/reportAction";
import { getAllCategorys } from "../../../redux/actions/categories";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import DatePicker from "react-date-picker";
 import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import moment from "moment";
import loader from "../../../style/loader/loader.scss";
import "../../../style/react-datetimepicker.scss";
import { CSVLink } from "react-csv";
import {aclUtil} from "../../util"

const history = createBrowserHistory();

const HorizontalLine = ({}) => <hr />;

const propTypes = {
  getReport: PropTypes.func.isRequired
};
let cityItems = [];
let isLoading = "false",
  csvData = [];
class OfferInventory extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    super(props);
    this.state = {
      menuKey: 'INVENTORY_REPORT',
      path: ["Home", "Inventory Report"],
      links: ["home", "report/offer-inventory"],
      date: new Date(),
      startDate: new Date(),
      range: false,
      disabled: false,
      isLoading: "false",
      csvData: "",
      reportData: "",
      historyPopup: false, 
      payoutHistory: '',
      offerIDs: '',
      merchantIDs: '',
      paymentTermID: '',
      payoutList: '',
      catData: '',
      catID: '',
      merchantTypeID: '',
      dealType: '',
      totalRecords: 0,
      based_on:'open_offers',
    };

    this.validate = this.validate.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.Clear = this.Clear.bind(this);
    this.changeDatePicker = this.changeDatePicker.bind(this);
  }

  onChangeStartDate = (date) => {
   
    if (date instanceof Date && !isNaN(date)) {
         this.setState({
          startDate: date,
           dobError: false // Reset error state if a valid date is selected
         });
       } 
       else if(date  === null)
       {
        this.setState({
          startDate: '',
          dobError: false // Reset error state if a valid date is selected
        });
       }
       else {
         // Handle invalid date (optional)
       //  console.error('Invalid date selected:', selectedDate);
      
         this.setState({
      
        dobError: true // Set error state to indicate invalid date
           
         });
    
       }
     };
  // onChangeStartDateRange = date => this.setState({ startDateRange: date });

  onChangeStartDateRange = date => {
    
   
    if (date && date[0] instanceof Date && !isNaN(date[0])) {

         this.setState({
          startDateRange: date,
           dobError: false // Reset error state if a valid date is selected
         });
       } 
       else if(date  === null)
       {
        this.setState({
          startDateRange: '',
          dobError: false // Reset error state if a valid date is selected
        });
       }
       else {
         // Handle invalid date (optional)
       //  console.error('Invalid date selected:', selectedDate);
      
         this.setState({
      
        dobError: true // Set error state to indicate invalid date
           
         });
    
       }
     };
  changeDatePicker = status => {
    if (this.state.range == false) {
      this.setState({ range: true });
    } else {
      this.setState({ range: false });
    }
  };

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  handleChange(e) {
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    this.setState({ [e.target.name]: e.target.value });
  }

  validate = () => {
    let isError = false;
    const errors = {};
    return isError;
  };

  handleSubmit(e) {
    e.preventDefault();
    const err = this.validate();
    let formData;

    if (!err) {
      isLoading = "true";   
        formData = {
          based_on: this.state.based_on,
          dealType: this.state.dealType,
          catID: this.state.catID,
        };   
          if (this.state.range == true) {
        let dateRange = this.state.startDateRange;
        formData.startDate = moment(dateRange[0]).format('YYYY-MM-DD');
        formData.endDate = moment(dateRange[1]).format('YYYY-MM-DD');
      } else {
        if(this.state.startDate){
        formData.startDate = moment(this.state.startDate).format('YYYY-MM-DD') ? moment(this.state.startDate).format('YYYY-MM-DD') : '';
      }
      } 

      this.props.getReport(formData, 'report/offer-inventory');
    } else {
      isLoading = "false";
    }
  }

  Clear = () => {};

  handlePageChange = page => {};

  componentWillMount() {
    isLoading = "true";
    this.props.clearAlert();
    this.handleDismiss();
    this.props.getAllCategorys({page:0});
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    if(siteData) {
      if(siteData.combine_products == 'disable') {
        this.setState({dealType: 'offer'});
        this.props.getReport({based_on: this.state.based_on, dealType:'offer'}, 'report/offer-inventory');
      }else{
        this.props.getReport({based_on: this.state.based_on, dealType:''}, 'report/offer-inventory');
      }
    }    
    
  }
  componentWillReceiveProps(nextProps) {

    if(!aclUtil.isPrimaryMenuAccessible(this.state.menuKey)){
      this.context.router.history.push("/restrictedAccess");
    }

    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.error);
        isLoading = "false";
      }
    }

    if (this.props.reportData !== nextProps.reportData) {
      if (nextProps.reportData) {
        isLoading = "false";
        this.setState({ totalRecords: nextProps.reportData.total_record});
        this.setState({ reportData: nextProps.reportData});
        this.handleExport(nextProps.reportData);
      }
    }

    if (this.props.catData !== nextProps.catData) {
      if (nextProps.catData) {
        isLoading = "false";
        this.setState({ catData: nextProps.catData.data });
      }
    }

    if (nextProps.message) {
      isLoading = "false";
      this.handleShow();
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType
      });
    }


  }

  handleExport = data => {
    let dateRange;
    if (this.state.range == true && this.state.startDateRange) {
    dateRange = this.state.startDateRange;
    }
    let setDate = (this.state.range == true && this.state.startDateRange) ? moment(dateRange[0]).format('MM/DD/YYYY') +' - '+moment(dateRange[1]).format('MM/DD/YYYY') : moment(this.state.startDate).format('MM/DD/YYYY');
    csvData = [
      [
        'Type',
        'Merchant Name',
        'Offer ID',
        'Offer Name',
        'Offer Price',
        'Start Date',
        'End Date',
        'Remittance',
        'Market',
        'Sales Rep',
        'Voucher To be Sold',
        'Total Sold',
        'Quantity Refunded',
        'Total Remaining',
        'Gross Sale',
      ]
    ];

    {data &&
      data.data.map((offerinvData, offerinvIndex) => 
        csvData.push([
          (offerinvData.proposal_type == '10') ? 'Product' : (offerinvData.proposal_type == '10') ? 'Auction' : 'Offer',
          offerinvData.merchantName,
          offerinvData.dealID,
          offerinvData.dealText,
          offerinvData.offerPrice,
          offerinvData.startDateTime,
          offerinvData.expiryDateTime,
          offerinvData.remittance,
          offerinvData.title, 
          offerinvData.salesrep,
          offerinvData.vouchersToSold, 
          offerinvData.totalSold, 
          offerinvData.quantityRefunded,
          offerinvData.totalRemaining,
          offerinvData.grossSale,
        ])
      )
    }

    {data &&
      data.total && 
      csvData.push([
        'Total',
        '',
        '',
        '',
        '',
        '', 
        '',
        '', 
        '',
        data.total.vouchersToSold , 
        data.total.totalSold, 
        data.total.quantityRefunded,
        data.total.totalRemaining,
        data.total.grossSale,
      ])
    }

    this.setState({ csvData: csvData });
  };

  render() {
    let dateRange;
    if (this.state.range == true && this.state.startDateRange) {
    dateRange = this.state.startDateRange;
    }
    return (
      <div className="col-lg-12 add-sub-admin">
        {isLoading == "true" ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}

        <div className="row">
          <div className="col-xs-12">
            <BreadcrumbComponent path={this.state.path} links={this.state.links} context={this.context}/>
          </div>
        </div>
        <form onSubmit={this.handleSubmit}>
          <div className="panel">
            <header className="panel-heading">Inventory Report</header>
            <div className="panel-body">
              <Row>                            
                <Col md={3} xs={12}>
                  <FormGroup controlId="based_on">
                    <ControlLabel>Report By</ControlLabel>
                    <FormControl
                      componentClass="select"
                      style={{ borderColor: this.state.based_onError }}
                      name="based_on"
                      onChange={this.handleChange}
                      value={this.state.based_on}
                    >
                      <option value="open_offers">Open Offers</option>
                      <option value="closed_offers">Closed Offers</option> 
                    </FormControl>
                  </FormGroup>
                </Col> 
                  <Col md={3} xs={12}>
                  <ControlLabel>Date</ControlLabel>
                  <FormGroup controlId="formOfferTitle">
                    {this.state.range == false ? (
                      <DatePicker
                        onChange={this.onChangeStartDate}
                        value={this.state.startDate}
                      />
                    ) :
                
                    (
                      <DateRangePicker
                        onChange={this.onChangeStartDateRange}
                        value={this.state.startDateRange}
                      />
                   )
                    }
                  </FormGroup>
                </Col>
                <Col md={3} xs={12}>
                    <FormGroup controlId="formParentID">
                      <ControlLabel>Deal Type</ControlLabel>
                      <FormControl
                        componentClass="select"
                        name="dealType"
                        onChange={this.handleChange}
                        placeholder="select"
                        value={this.state.dealType}
                      >
                        <option value="">All</option>
                        <option value="offer">Offer</option>
                        <option value="products">Products</option>
                        <option value="auction">Auction</option>
                      </FormControl>
                    </FormGroup>
                </Col>  
                   <Col md={3} xs={12}>
                  <FormGroup controlId="catID">
                    <ControlLabel>Category</ControlLabel>
                    <FormControl
                      componentClass="select"
                      style={{ borderColor: this.state.catIDError }}
                      onChange={this.handleChange}
                      name="catID"
                      value={this.state.catID}
                    >
                      <option value="">All</option>
                      {!isEmpty(this.state.catData) &&
                        this.state.catData.map((type, index) => (
                          <option key={type.catID} value={type.catID}>
                            {type.catName}
                          </option>
                        ))}
                    </FormControl>
                  </FormGroup>
                </Col>      
              </Row>
              <Row>
                <Col md={12} xs={12}>
                  <Button
                    bsStyle="info"
                    type="submit"
                    id="saveButton"
                    disabled={this.state.disabled}
                  >
                    Submit
                  </Button>
                  {this.state.range == false ? (
                    <a
                      className="btn btn-success"
                      type="submit"
                      onClick={this.changeDatePicker}
                      id="saveButton"
                    >
                      Use Range
                    </a>
                  ) : (
                    <a
                      className="btn btn-success"
                      type="submit"
                      onClick={this.changeDatePicker}
                      id="saveButton"
                    >
                      Use Date
                    </a>
                  )}
                  {this.state.csvData ? (
                    <CSVLink
                      data={this.state.csvData}
                      filename={"offerinventory-report.csv"}
                      className="btn btn-default"
                    >
                      Export CSV
                    </CSVLink>
                  ) : null}
                </Col>
              </Row>
            </div>
          </div>
        </form>
        {/**end contract information **/}

        <div className="panel">
          <div className="panel-body table-responsive">
            <table className="table table-hover table-bordered">
              <thead>
                <tr>
                  <th>Type</th>
                  <th>Merchant Name</th>
                  <th>Offer ID</th>
                  <th>Offer Name</th>
                  <th>Offer Price</th>
                  <th>Start Date</th>
                  <th>End Date</th>
                  <th>Remittance</th>
                  <th>Market</th> 
                  <th>Sales Rep</th>
                  <th>Voucher To be Sold</th> 
                  <th>Total Sold</th> 
                  <th>Quantity Refunded</th> 
                  <th>Total Remaining</th> 
                  <th>Gross Sale</th> 
                </tr>
              </thead>
              <tbody>
              {this.state.reportData ?
                  this.state.reportData.data.map((offerinvData, offerinvIndex) =>
                    <tr key={offerinvData.offerID + offerinvIndex}>
                      <td>{(offerinvData.proposal_type == '10') ? 'Product' : (offerinvData.proposal_type == '11') ? 'Auction' : 'Offer'}</td>
                      <td>{offerinvData.merchantName}</td>
                      <td>{offerinvData.dealID}</td>
                      <td>{offerinvData.dealText}</td>
                      <td>{offerinvData.offerPrice}</td>
                      <td>{offerinvData.startDateTime}</td>
                      <td>{offerinvData.expiryDateTime}</td>
                      <td>{offerinvData.remittance}</td>
                      <td>{offerinvData.title}</td>
                      <td>{offerinvData.salesrep}</td>
                      <td>{offerinvData.vouchersToSold}</td> 
                      <td>{offerinvData.totalSold }</td> 
                      <td>{offerinvData.quantityRefunded}</td> 
                      <td>{offerinvData.totalRemaining}</td> 
                      <td>{offerinvData.grossSale }</td> 
                    </tr> 
                  )
                :
                <tr><td colSpan="14">Data Not Found</td></tr>
              }
              {this.state.reportData.total && 
                <tr key={Math.random()}>
                  <td colSpan="9">Total</td> 
                  <td>{this.state.reportData.total.vouchersToSold}</td> 
                  <td>{this.state.reportData.total.totalSold }</td> 
                  <td>{this.state.reportData.total.quantityRefunded}</td> 
                  <td>{this.state.reportData.total.totalRemaining}</td> 
                  <td>{this.state.reportData.total.grossSale }</td> 
                </tr>
              }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    error: state.reportReducer.error,
    alertType: state.alertsReducer.alertType,
    message: state.alertsReducer.message,
    reportData: state.reportReducer.reportData,
    catData: state.categoryReducer.catData,
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, {
    renderAlert,
    clearAlert,
    getReport,
    getAllCategorys,
  })
)(OfferInventory);



// WEBPACK FOOTER //
// ./src/app/views/admin/reports/OfferInventory.js